var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 34,
    viewBox: "0 0 122 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_316_1261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 122,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 0H0V33.0412H122V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_316_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4336 7.8125H61.2579V11.0749C63.166 8.14306 65.3615 7.8125 68.577 7.8125V13.5776H67.113C63.261 13.5776 61.417 15.3907 61.417 18.9812V25.1089H55.4336V7.8125Z",
    fill: "#0500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0061 25.1089H82.0252V23.4598C80.719 24.9757 78.9391 25.6344 76.7436 25.6344C72.5758 25.6344 70.2188 23.1626 70.2188 18.6174V7.8125H76.2009V17.2692C76.2009 19.4092 77.2505 20.6612 79.0316 20.6612C80.8127 20.6612 82.0239 19.4413 82.0239 17.3679V7.8125H88.0061V25.1089Z",
    fill: "#0500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4688 19.7686H95.071C95.3263 21.0205 96.186 21.5472 98.252 21.5472C99.9394 21.5472 100.926 21.1525 100.926 20.4285C100.926 19.8672 100.449 19.5046 99.0821 19.2086L94.5628 18.1861C91.5397 17.4954 90.0115 15.7488 90.0115 12.9477C90.0115 9.25603 92.7151 7.34668 97.9671 7.34668C103.218 7.34668 105.794 9.20793 106.242 13.1956H100.674C100.58 12.1423 99.4966 11.4984 97.7155 11.4984C96.2847 11.4984 95.3633 11.9585 95.3633 12.6517C95.3633 13.2437 95.9665 13.705 97.1777 14.0035L101.918 15.1568C105.036 15.9129 106.533 17.4954 106.533 20.0646C106.533 23.6243 103.446 25.7322 98.1978 25.7322C92.9495 25.7322 89.4786 23.459 89.4786 19.7673H89.4724H89.4688V19.7686Z",
    fill: "#0500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.461 13.1927V7.8125H107.695V13.1952H112.101V25.1089H118.052V13.1927H122.461Z",
    fill: "#0500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7681 13.1927V7.8125H39.0039V13.1952H43.4097V25.1089H49.3623V13.1927H53.7681Z",
    fill: "#0500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.273438 4.77241L14.9587 -0.000976562V33.0402C4.46957 28.6344 0.273438 20.1903 0.273438 15.4182V4.77241Z",
    fill: "#0500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6462 4.77241L14.9609 -0.000976562V33.0402C25.45 28.6344 29.6462 20.1903 29.6462 15.4182V4.77241Z",
    fill: "url(#paint0_linear_316_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6462 4.77241L14.9609 -0.000976562V33.0402C25.45 28.6344 29.6462 20.1903 29.6462 15.4182V4.77241Z",
    fill: "url(#paint1_linear_316_1261)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_1261",
    x1: 14.3408,
    y1: 37.1945,
    x2: 26.3611,
    y2: -6.28055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0500FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_1261",
    x1: 25.6035,
    y1: -1.86748,
    x2: 14.5113,
    y2: 33.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0500FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/Trust.0f506a4d01a634fcc3a7a8dfd7ba6e2f.svg";
export { ForwardRef as ReactComponent };